// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"131":"ShopEdit","186":"ShopAdd","443":"about","687":"ShopList"}[chunkId] || chunkId) + "." + {"131":"f933811f","186":"5e78f13c","443":"8048e045","491":"5eb1a5e8","687":"dc494f81"}[chunkId] + ".js";
};